// Default CAD settings for PlateSnap
export const DEFAULT_SETTINGS = {
  thickness: 2,       // plate thickness (mm)
  tolerance: 0.07,    // inward offset per side of male peg (mm)
  pegShape: "square", // "square" | "diamond"
  pegSize: 4,         // female cross-section size (mm)
  maleHeight: 1.3,    // male peg height (mm)
  femaleExtra: 0.2,   // female depth beyond male height (mm)
  chamfer: 0.02,      // chamfer on male & female (mm)
  edgeChamfer: 1.5,   // chamfer/fillet on plate outline edges (mm)
  edgeType: "chamfer", // "chamfer" | "fillet"
};

export const DEFAULT_SNAP = { enabled: false, size: 1, edge: false }; // grid + edge snap (mm)

export const BASE_COLOR = "#22C55E"; // base model is green
export const LEVEL_COLORS = [
  "#3B82F6", "#EAB308", "#F97316", "#A855F7",
  "#EC4899", "#14B8A6", "#F43F5E", "#84CC16",
];
export const levelColor = (lvl) => {
  const n = LEVEL_COLORS.length;
  return LEVEL_COLORS[(((lvl || 0) % n) + n) % n];
};
export const EDGE_INSET = 2; // edge-snap stays this far inside the outline (mm)

export const PALETTE = [
  "#10B981", "#38BDF8", "#F59E0B", "#F43F5E",
  "#A78BFA", "#22D3EE", "#FB7185", "#84CC16",
];

export const COLORS = {
  bg: "#090D16",
  surface: "#0F172A",
  surfaceHover: "#1E293B",
  border: "#1E293B",
  borderHi: "#334155",
  primary: "#10B981",
  male: "#38BDF8",
  female: "#F43F5E",
  grid: "#1E293B",
  axisX: "#EF4444",
  axisY: "#22C55E",
};

export const SHAPE_DEFS = {
  rectangle: { label: "Rectangle", params: { w: 40, h: 30 } },
  circle: { label: "Circle", params: { r: 20 } },
  triangle: { label: "Triangle", params: { r: 24 } },
  star: { label: "Star", params: { points: 5, outerR: 24, innerR: 11 } },
  polygon: { label: "Polygon", params: { sides: 6, r: 22 } },
};
